import type { Hookable } from 'hookable'
import type { Ref } from 'vue'

import type { BacklogContextEvents } from '../useBacklogContext.events.schema'

interface BacklogTeamSlugChangedLoggerLike {
  debug: (message: string, meta?: Record<string, unknown> | unknown) => void
}

export interface BacklogTeamSlugChangedHandlerParams {
  hooks: Hookable<{
    [K in keyof BacklogContextEvents]: (event: BacklogContextEvents[K]) => void | Promise<void>
  }>
  logger: BacklogTeamSlugChangedLoggerLike
  clearBacklogScopedQueries: () => void
  workitemsQueryKey: Ref<string | undefined>
}

/**
 * Registers a hook handler that clears backlog-scoped queries when the team slug changes.
 *
 * This avoids displaying the previous team's backlog while the team id is resolving.
 */
export default function useBacklogContextOnTeamSlugChanged({
  hooks,
  logger,
  clearBacklogScopedQueries,
  workitemsQueryKey,
}: BacklogTeamSlugChangedHandlerParams) {
  return hooks.hook('TeamSlugChanged', (event) => {
    workitemsQueryKey.value = undefined
    clearBacklogScopedQueries()
  })
}
